import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { MdmDrawer } from "src/components/MdmDrawer";

import { SecSpecSelectStore } from "./SecSpecSelectStore";
import { SelectSpecStep } from "./steps/SelectSpecStep";
import { TranslateSpecStep } from "./steps/TranslateSpecStep";
import { TranslateStep } from "./TranslateStep";

type PropsSecSpecSelectModal = {
  store: SecSpecSelectStore;
  open: boolean;
  close: () => void;
  onFinish: () => void;
};

export const SecSpecSelectModal: React.FC<PropsSecSpecSelectModal> = observer(
  (props) => {
    const { store, open, close: closeModal, onFinish } = props;
    const isDirect = store.linkType.code === 0;
    const [translateStep, setTranslateStep] = React.useState<TranslateStep>(
      TranslateStep.select,
    );

    React.useEffect(() => {
      if (open) {
        setTranslateStep(TranslateStep.select);
      }
    }, [open, store]);

    const hasSelectedCatalogs =
      (store.catalogsStore?.selectedRows.length ?? 0) > 0;

    const next = () => {
      const { selectedSpec } = store;
      if (selectedSpec) {
        store.setCatalogsStore(selectedSpec.id);
      }
      setTranslateStep(TranslateStep.translate);
    };

    const finishTranslation = () => {
      if (hasSelectedCatalogs) {
        onFinish();
      }
    };

    const title = isDirect
      ? "Добавление вторичной спецификации: прямая"
      : "Добавление вторичной спецификации: трансляция";

    const getExtra = () => {
      if (isDirect) {
        return (
          <Button type="primary" onClick={onFinish} disabled={!store.canApply}>
            Добавить
          </Button>
        );
      }

      if (translateStep === TranslateStep.select) {
        return (
          <Button type="primary" onClick={next} disabled={!store.canApply}>
            Далее
          </Button>
        );
      }

      return (
        <Flex align="center" gap={8}>
          <Button
            type="text"
            onClick={() => setTranslateStep(TranslateStep.select)}
            icon={<ArrowLeftOutlined />}
          >
            Назад
          </Button>
          <Button
            type="primary"
            onClick={finishTranslation}
            disabled={!hasSelectedCatalogs}
          >
            Добавить
          </Button>
        </Flex>
      );
    };

    return (
      <MdmDrawer
        open={open}
        wide
        onClose={closeModal}
        title={title}
        extra={getExtra()}
      >
        {isDirect ? (
          <SelectSpecStep store={store} />
        ) : (
          <TranslateSpecStep store={store} current={translateStep} />
        )}
      </MdmDrawer>
    );
  },
);
